import clsx from "clsx";
import Flag from "react-country-flag";

import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./Location.module.css";

const ref = "location";

interface LocationProps extends Partial<CommonProps> {
  countryCode: string;
  location: Array<string>;
}

function useLocation(props: LocationProps) {
  const className = clsx(styles[ref], props.className);
  const { countryCode = "UK", id = createId(ref), location } = props;
  const breadcrumbs = location.length > 0 ? <>{location.join(", ")}</> : null;

  return {
    breadcrumbs,
    className,
    countryCode: countryCode.toUpperCase().replace(/_/g, "-"),
    id,
  };
}

function Location(props: LocationProps) {
  const { breadcrumbs, className, countryCode, id } = useLocation(props);

  return breadcrumbs && countryCode ? (
    <section className={className} id={id}>
      <Flag
        svg
        className={styles.flag}
        countryCode={countryCode}
        style={{ width: "var(--col)", height: "auto" }}
      />

      <span>{breadcrumbs}</span>
    </section>
  ) : null;
}

export default Location;
export { Location, type LocationProps };
